import Vue from 'vue'
import axios from 'axios'
import cookie from 'js-cookie'
import router from '@/router'
import { userTokenKey } from '@/config/index'
const commonApiList = [ // 绕过多语言替换的接口清单
  '/api/project/version',
  '/api/project/time'
]
const routerLangKey = 'zh_CN'
const {
  VUE_APP_API_ORIGIN,
  NODE_ENV
} = process.env
const apiBase = NODE_ENV === 'development' ? '' : VUE_APP_API_ORIGIN
let loadingInstance = null

function closeLoading() {
  if (loadingInstance) {
    loadingInstance.clear()
    loadingInstance = null
  }
}

axios.interceptors.request.use(
  config => {
    const token = cookie.get(userTokenKey);

    if (!commonApiList.filter(i => config.url.includes(i)).length) {
      config.url = config.url.replace('/api/', `/api/${routerLangKey}/`)
    }
    
    if (token) {
      config.headers = {
        'Authorization': `Bearer ${token}`
      }
    }

    return config
  },
  error => {
    return Promise.reject(error)
  }
)

axios.interceptors.response.use(
  response => {
    const code = Number(response.data.code)
    const refreshToken = response.data.refresh_token
    const token = cookie.get(userTokenKey)
    if (refreshToken && refreshToken !== token) {
      cookie.set(userTokenKey, refreshToken)
    }
    if(code === 400 || code === 401 || code === 7000){
      cookie.remove(userTokenKey)
      router.replace('/login')
    }

    return response
  },
  error => {
    if (error.response.status === 500) {
      Vue.prototype.$Toast.fail('请求失败')
    }
    return Promise.reject(error)
  }
)

export default (method, url, params = {}, options = {}) => {
  return new Promise((resolve, reject) => {
    let query = params
    if (method === 'get') {
      query = { params }
    }

    if (!options || !options.silence) {
      loadingInstance = loadingInstance || Vue.prototype.$Toast.loading({
        forbidClick: true,
        message: '加载中...'
      })
    }

    axios[method](`${apiBase}${url}`, query)
    .then((res) => {
      if (res) {
        const data = res.data
        const code = Number(data.code)
        if (code === 200) {
          resolve(data.data)

          closeLoading()
        } else {
          Vue.prototype.$Toast.fail(data.msg)
          
          resolve(null)
        }
      }
    })
    .catch((error) => {
      reject(error)
      closeLoading()
    })
  })
}